/* eslint camelcase: "off" */
/* globals window, $ */

'use strict';

Number.isInteger =
  Number.isInteger ||
  function (value) {
    return (
      typeof value === 'number' &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  };

/**
 * Number.prototype.format(n, x, s, c)
 *
 * @param integer n: length of decimal
 * @param integer x: length of whole part
 * @param mixed   s: sections delimiter
 * @param mixed   c: decimal delimiter
 */
Number.prototype.format = function (n, x, s, c) {
  let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
    num = this.toFixed(Math.max(0, n));

  return (c ? num.replace('.', c) : num).replace(
    new RegExp(re, 'g'),
    '$&' + (s || ','),
  );
};

$.extend($.easing, {
  easeInOutQuint: function (x, t, b, c, d) {
    if ((t /= d / 2) < 1) {
      return (c / 2) * t * t * t * t * t + b;
    }
    return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
  },
});

$(function () {
  var timer = 0;
  // Default time delay before checking location
  var callBackTime = 50;

  // On scroll
  $(window).on('scroll', function () {
    if (timer) {
      clearTimeout(timer);
    }
    // Use a buffer so we don't call trackLocation too often.
    timer = setTimeout(trackLocation, callBackTime);
  });

  // Scroll to div
  $('a[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, '') ===
        this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({ scrollTop: target.offset().top }, 800);
        return false;
      }
    }
  });

  function trackLocation() {
    //This empty function prevents the nav bar from glitching.. ?! (Sorry)
  }

  var video = $('#device-video');
  var videoLoaded = false;
  video.bind('timeupdate pagehide', function () {
    if (!videoLoaded) {
      videoLoaded = true;
      video.addClass('loaded');
      $('#video-background').addClass('loaded');
    }
  });

  runWhenVideoLoaded($('#video-background'), function (video) {
    video[0].pause();
  });

  $(window).one('beforeunload', function () {
    $('video').hide();
  });

  // Portfolio calculator
  let pc = $('.portfolio-calculator');
  let wm = $('.portfolio-calculator__output__wealth-wrapper');
  let wmLink = $('.portfolio-calculator__output__wealth-wrapper a');
  const pcMin = 0;
  const pcMax = 10000;
  let pcInitialText = pc.find(
    '.portfolio-calculator__inputs__input--initial .portfolio-calculator__inputs__input__sum__value',
  );
  let pcInitialVal = pc.find(
    '.portfolio-calculator__inputs__input--initial input[type=range]',
  );
  let pcMonthlyText = pc.find(
    '.portfolio-calculator__inputs__input--monthly .portfolio-calculator__inputs__input__sum__value',
  );
  let pcMonthlyVal = pc.find(
    '.portfolio-calculator__inputs__input--monthly input[type=range]',
  );
  let pcResultText = pc.find('.portfolio-calculator__output__sum__value');
  pcInitialVal.attr('min', pcMin);
  pcInitialVal.attr('max', pcMax);
  pcMonthlyVal.attr('min', pcMin);
  pcMonthlyVal.attr('max', pcMax);

  let yearsIndex = 3;
  const yearsLabel = $('.portfolio-calculator__output__years');

  let previousValue = 0;

  let pcOnChange = function (animateValueChange) {
    const inp = pcInitialVal.val() / (pcMax - pcMin);
    const initialInvestment =
      inp <= 0.3
        ? Math.round(((inp / 0.3) * 100000) / 1000) * 1000
        : inp <= 0.75
          ? 100000 +
            Math.round((((inp - 0.3) / 0.45) * 1000000) / 10000) * 10000
          : inp < 0.95
            ? 1000000 +
              Math.round((((inp - 0.75) / 0.2) * 4000000) / 100000) * 100000
            : 5000000;
    const mp = pcMonthlyVal.val() / (pcMax - pcMin);
    const monthlyInvestment = Math.round((mp * 20000) / 100) * 100;

    pcInitialText.text(initialInvestment.format(0, 3, '  ', '.'));
    pcMonthlyText.text(monthlyInvestment.format(0, 3, '  ', '.'));

    pcInitialVal.attr('style', '--progress: ' + inp * 100 + '%');
    pcMonthlyVal.attr('style', '--progress: ' + mp * 100 + '%');

    let years;

    switch (yearsIndex) {
      case 0: {
        years = 1;
        break;
      }
      case 1: {
        years = 5;
        break;
      }
      case 2: {
        years = 10;
        break;
      }
      case 3: {
        years = 15;
        break;
      }
      case 4: {
        years = 30;
        break;
      }
    }

    yearsLabel.html(`${years}&nbsp;år`);

    const returnEstimatesKey = years === 1 ? '1-year' : `${years}-years`;
    const estimatedValueAfterNYears =
      // `returnEstimates` is injected in `index.hbs`
      // eslint-disable-next-line no-undef
      returnEstimates[returnEstimatesKey]['mean'];

    const months = years * 12;
    const returnPerMonth =
      Math.pow(1 + estimatedValueAfterNYears, 1 / months) - 1;

    const resultValue = valueAfterPeriods(
      initialInvestment,
      monthlyInvestment,
      returnPerMonth,
      months,
    );

    const formatValue = (resultValue) => {
      const roundToValue =
        resultValue >= 100000 ? 10000 : resultValue >= 25000 ? 1000 : 100;
      pcResultText.text(
        (Math.round(resultValue / roundToValue) * roundToValue).format(
          0,
          3,
          '  ',
          '.',
        ),
      );
    };

    if (animateValueChange === true) {
      $({ val: previousValue }).animate(
        { val: resultValue },
        {
          duration: 250,
          easing: 'linear',
          step: (value) => formatValue(value),
          complete: () => {
            previousValue = resultValue;
          },
        },
      );
    } else {
      previousValue = resultValue;
      formatValue(resultValue);
    }

    if (initialInvestment >= 5000000) {
      wm.addClass('active');
      wmLink.attr('aria-hidden', 'false');
      wmLink.attr('tabindex', '0');
    } else {
      wm.removeClass('active');
      wmLink.attr('aria-hidden', 'true');
      wmLink.attr('tabindex', '-1');
    }
  };
  pc.on('input change', pcOnChange);

  // Show or hide portfolio calculator year picker
  $('.portfolio-calculator__output__button').click((event) => {
    const button = $(event.currentTarget);
    button.attr('aria-expanded', (_, val) =>
      val === 'true' ? 'false' : 'true',
    );

    const dropdownContent = $('.portfolio-calculator__output__dropdown');
    dropdownContent.toggleClass('show');
    dropdownContent.attr('aria-hidden', (_, val) =>
      val === 'false' ? 'true' : 'false',
    );

    const options = $('.portfolio-calculator__output__dropdown button');
    options.attr('tabindex', (_, val) => (val === '0' ? '-1' : '0'));
  });

  // Pick number of years to show
  $('.portfolio-calculator__output__dropdown button').click((evt) => {
    let index = Array.from(evt.target.parentElement.children).indexOf(
      evt.target,
    );

    yearsIndex = index;
    pcOnChange(true);
  });

  // Animate the slider when it scrolls into view
  $(window).bind('scroll.portfolio-calculator', function () {
    let rect = pc[0].getBoundingClientRect();
    let elemTop = rect.top;
    let elemBottom = rect.bottom;
    let visible = elemTop >= 0 && elemBottom <= window.innerHeight;
    if (visible) {
      $(window).unbind('.portfolio-calculator');
      pcInitialVal.val(0).change();
      pcInitialVal.animate(
        { value: pcMin + (pcMax - pcMin) * 0.3 },
        {
          duration: 1400,
          easing: 'easeInOutQuint',
          step: function () {
            pcInitialVal.change();
          },
        },
      );
      pcMonthlyVal.val(0).change();
      pcMonthlyVal.animate(
        { value: Math.round(pcMin + (pcMax - pcMin) * (3000 / 20000)) },
        {
          duration: 1400,
          easing: 'easeInOutQuint',
          step: function () {
            pcMonthlyVal.change();
          },
        },
      );
    }
  });

  // Scroll-into-view animation
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');

        if (entry.target.id === 'testimonial-carousel') {
          // Testimonial horizontal scroll on scroll-into-view
          entry.target.scroll({ left: 32, behavior: 'smooth' });
        }

        obs.unobserve(entry.target);
      }
    });
  });
  document.querySelectorAll('.appear-container').forEach((el) => {
    observer.observe(el);
  });

  // Testimonial carousel
  const carousel = $('#testimonial-carousel');
  // Offset testimonial horizontal scroll before scroll-into-view
  carousel.get(0).scroll(600, 0);

  let isMouseDown = false;
  let startX;
  let lastX;
  let scrollLeft;
  let momentum = 0;
  let lastTime = null;
  const friction = 0.965;

  carousel.on('mousedown', (e) => {
    isMouseDown = true;
    carousel.addClass('active');

    startX = e.clientX - carousel.get(0).offsetLeft;
    scrollLeft = carousel.get(0).scrollLeft;
  });

  carousel.on('mouseleave', () => {
    isMouseDown = false;
    carousel.removeClass('active');
    animateCarousel();
  });

  carousel.on('mouseup', () => {
    isMouseDown = false;
    carousel.removeClass('active');
    animateCarousel();
  });

  carousel.on('mousemove', (e) => {
    if (!isMouseDown) {
      return;
    }
    e.preventDefault();

    const currentTime = performance.now();
    if (lastTime !== null) {
      const deltaTime = currentTime - lastTime; // time difference in ms
      // Calculate differences in position
      const deltaX = e.clientX - lastX;

      // Compute the velocity in pixels per millisecond
      momentum = deltaX / deltaTime;
    }

    // Update last known values
    lastX = e.clientX;
    lastTime = currentTime;

    // update scroll
    const x = e.pageX - carousel.get(0).offsetLeft;
    const walk = x - startX;
    carousel.get(0).scrollLeft = scrollLeft - walk;
  });

  // Continue scrolling with momentum using friction:
  function animateCarousel() {
    if (Math.abs(momentum) > 0.01) {
      carousel.get(0).scrollLeft -= momentum * 16; // multiplying by ~16 as nominal frame time in ms

      momentum *= friction;
      requestAnimationFrame(animateCarousel);
    } else {
      momentum = 0;
    }
  }
});

function runWhenVideoLoaded(video, f) {
  video.one('timeupdate', function () {
    f(video);
  });
}

$(document).ready(function () {
  // Get Google AdWords script
  var pclass = urlParam('pclass');
  $('.pricing').addClass(pclass);
  $.getScript('//www.googleadservices.com/pagead/conversion_async.js');
});

function urlParam(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
    window.location.href,
  );
  if (results === null) {
    return null;
  } else {
    return decodeURI(results[1]) || 0;
  }
}

function valueAfterPeriods(
  initialInvestment,
  investmentPerPeriod,
  interestRatePerPeriod,
  numberOfPeriods,
) {
  let value = initialInvestment;

  for (let index = 0; index < numberOfPeriods; index++) {
    value += value * interestRatePerPeriod + investmentPerPeriod;
  }

  return value;
}
